import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { RootState } from '../../store';
import { useWithdrawalGlobalState } from '../../hooks/useWithdrawalGlobalState';
import { normalizeWithdrawalPanelMode } from '../../utils/parishWithdrawalPanel';

const SaqueRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useSelector((state: RootState) => state.auth);

  const { data: withdrawalGlobalState, isLoading } = useWithdrawalGlobalState();

  // Só redireciona se explicitamente for subparóquia.
  if (user?.parish?.isMainParish === false) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (withdrawalGlobalState && !withdrawalGlobalState.enabled) {
    return <Navigate to="/dashboard" replace />;
  }

  const withdrawalPanelMode = normalizeWithdrawalPanelMode(user?.parish?.features?.withdrawalPanelMode);
  if (withdrawalPanelMode === 'hidden') {
    return <Navigate to="/dashboard" replace />;
  }

  if (user?.allowWithdrawalAccess === false) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default SaqueRouteGuard;
